import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import { IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
/**
 * CleanHeaderLoggedOptions.
 *
 * @param {HeaderLoggedProps} props header's props
 * @returns {React.FC<HeaderLoggedProps>} CleanHeaderLoggedOptions.
 */
var CleanHeaderLoggedOptions = function (options) {
    var _a = React.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var handleMenu = function (event) { return setAnchorEl(event.currentTarget); };
    var handleClose = function () { return setAnchorEl(null); };
    return (React.createElement("div", { "data-testid": 'header-logged-options', className: options.className },
        React.createElement(IconButton, { "aria-label": 'account of current user', "aria-controls": 'menu-appbar', "aria-haspopup": 'true', onClick: handleMenu, color: 'inherit', className: 'avatar-icon' },
            React.createElement(AccountCircleIcon, null),
            React.createElement(Typography, { variant: 'h6', className: 'username', "data-testid": 'header-username' }, options.username)),
        React.createElement(Menu, { id: 'menu-appbar', anchorEl: anchorEl, anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }, keepMounted: true, transformOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }, open: open, onClose: handleClose }, options.dropdownLinks.map(function (link) { return (React.createElement(Link, { to: link.uri, key: link.uri, onClick: handleClose },
            React.createElement(MenuItem, null, link.label))); }))));
};
export var HeaderLoggedOptions = styled(function (_a) {
    var props = __rest(_a, []);
    return React.createElement(CleanHeaderLoggedOptions, __assign({}, props));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: contents;\n\n  .avatar-icon {\n    svg {\n      width: 45px;\n      height: 45px;\n      padding: 0 10px;\n    }\n  }\n  .username {\n    cursor: auto;\n    display: contents;\n  }\n"], ["\n  display: contents;\n\n  .avatar-icon {\n    svg {\n      width: 45px;\n      height: 45px;\n      padding: 0 10px;\n    }\n  }\n  .username {\n    cursor: auto;\n    display: contents;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=LoggedOptions.js.map